import { useEffect, useRef, useState } from "react";
import SessionExpired from "./SessionExpired.js";


const SESSION_TIMEOUT = 20 * 60 * 1000;
// const SESSION_TIMEOUT = 5 * 1000;

const SessionTimeoutWrapper = ({children}) => { 
    const [expired, setExpired] = useState(false);
    const timeoutRef = useRef();
    const micActiveRef = useRef(false);
    const lastActivityRef = useRef(Date.now());

    const resetTimer = () => { 
        clearTimeout(timeoutRef.current);
        lastActivityRef.current = Date.now();
        if(!micActiveRef.current){
        timeoutRef.current = setTimeout(() => { 
                const inactiveTime = Date.now() - lastActivityRef.current;
                // console.log(` session inactive for ${(inactiveTime / 1000).toFixed(2)} minutes`);
                setExpired(true);
            }, SESSION_TIMEOUT);
        } 
    };
    
    useEffect(() => { 

        const micOn = () => { 
            micActiveRef.current = true;
            clearTimeout(timeoutRef.current);
        }
        
        const micOff = () => { 
            micActiveRef.current = false;
            resetTimer();
        }

        window.addEventListener("micActivated", micOn);
        window.addEventListener("micDeactivated", micOff);

        const events = [ "mousemove", "mousedown", "keypress", "scroll", "touchstart", "click" ];
        events.forEach((event) => window.addEventListener(event, resetTimer));

        resetTimer();

        return () => { 
            clearTimeout(timeoutRef.current);
             window.removeEventListener("micActivated", micOn);
             window.removeEventListener("micDeactivated", micOff);
            events.forEach((event) => window.removeEventListener(event, resetTimer));
        };
    }, []);

    if(expired) return <SessionExpired />;

    return <> {children} </>;
    
};

export default SessionTimeoutWrapper;